export type NotificationPeriod = 'TODAY' | 'THIS_WEEK' | 'THIS_MONTH';

export class NotificationDateFilter {

  static readonly periods: Array<{ value: NotificationPeriod; label: string }> = [
    { value: 'TODAY', label: 'Today' },
    { value: 'THIS_WEEK', label: 'This week' },
    { value: 'THIS_MONTH', label: 'This month' },
  ];

  static fromQuery(value: string): NotificationPeriod {
    if (value === 'THIS_WEEK' || value === 'THIS_MONTH') {
      return value;
    }
    return 'TODAY';
  }

  static monthDays(period: NotificationPeriod, referenceDate: Date = new Date()): string[] {
    if (period === 'THIS_MONTH') {
      const lastDay = new Date(
        referenceDate.getFullYear(),
        referenceDate.getMonth() + 1,
        0,
      ).getDate();
      return Array.from({ length: lastDay }, (_, index) =>
        this.formatMonthDay(new Date(referenceDate.getFullYear(), referenceDate.getMonth(), index + 1)),
      );
    }

    if (period === 'THIS_WEEK') {
      const start = new Date(
        referenceDate.getFullYear(),
        referenceDate.getMonth(),
        referenceDate.getDate(),
      );
      const daysSinceMonday = (start.getDay() + 6) % 7;
      start.setDate(start.getDate() - daysSinceMonday);
      return Array.from({ length: 7 }, (_, index) => {
        const date = new Date(start.getFullYear(), start.getMonth(), start.getDate() + index);
        return this.formatMonthDay(date);
      });
    }

    return [this.formatMonthDay(referenceDate)];
  }

  private static formatMonthDay(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${month}-${day}`;
  }
}
